
export default [
    {
        path: "/",
        component: () => import('@/pages/HomeVueLayout.vue'),
        meta: {
            title: '首页',
            showInMenu: true,
            showSideMenu: false,
        },
        name: 'home',
        showInMenu: true,
        showSideMenu: false,
        children:[
            {
                meta: {
                    title: '首页',
                    showInMenu: false,
                    showSideMenu: false,
                },
                path: '/',
                component: () => import( '@/pages/home/HomePage.vue'),
                name:'home',
            }
        ]
    },
    {
        path: "/wechat/bindWx",
        component: () => import('@/pages/user/WxCallback.vue'),
        meta: {
            title: '首页',
            showInMenu: false,
            showSideMenu: false,
        },
        name: 'bindWx',
        showInMenu: false,
        showSideMenu: false,
    },
    {
        path: "/common/article/detail",
        component: () => import('@/pages/home/ArticleDetailPage.vue'),
        meta: {
            title: '文章详情',
            showInMenu: false,
            showSideMenu: false,
        },
        name: 'common.article.detail',
        children:[]
    },
    {
        path: "/product",
        component: () => import('@/pages/VueLayout.vue'),
        meta: {
            title: '哈皮',
            showInMenu: true,
            showSideMenu: false,
        },
        name: 'product',
        showInMenu: true,
        showSideMenu: false,
        children:[
            {
                meta: {
                    title: '商品',
                    showInMenu: false,
                    showSideMenu: false,
                },
                path: '/product',
                component: () => import( '@/pages/home/HomeFilterPage.vue'),
                name:'product',
            },
            {
                meta: {
                    title: '商品详情',
                    showInMenu: false,
                    showSideMenu: false,
                },
                path: '/productDetail',
                component: () => import( '@/pages/home/ProductDetailPage.vue'),
                name:'productDetail',
            },
        ]
    },
    {
        path: "/order",
        component: () => import('@/pages/VueLayout.vue'),
        meta: {
            title: '订单',
            showInMenu: true,
            showSideMenu: false,
        },
        name: 'order',
        children:[
            {
                meta: {
                    title: '购物车',
                    showInMenu: true,
                    showSideMenu: false,
                },
                path: '/order/cart',
                component: () => import( '@/pages/order/UserCartOrderPage.vue'),
                name:'order.cart',
            },
            {
                meta: {
                    title: '订单支付',
                    showInMenu: false,
                    showSideMenu: false,
                },
                path: '/order/pay',
                component: () => import( '@/pages/order/UserOrderPayPage.vue'),
                name:'order.pay',
            },
        ]
    },
    {
        path: "/user",
        component: () => import('@/pages/user/UserHomeLayout.vue'),
        meta: {
            title: '我的账户',
            showInMenu: true,
            showSideMenu: true,
        },
        name: 'user',
        children:[
            {
                meta: {
                    title: '个人主页',
                    showInMenu: true,
                    showSideMenu: true,
                },
                path: '/user/home',
                component: () => import( '@/pages/user/UserHome.vue'),
                name:'user.home',
            },
            {
                meta: {
                    title: '基本信息',
                    showInMenu: true,
                    showSideMenu: true,
                },
                path: '/user/info',
                component: () => import( '@/pages/user/UserInfoPage.vue'),
                name:'user.info',
            },
            {
                meta: {
                    title: '地址管理',
                    showInMenu: true,
                    showSideMenu: true,
                },
                path: '/user/address',
                component: () => import( '@/pages/user/UserAddress.vue'),
                name:'user.address',
            },
            {
                meta: {
                    title: '安全中心',
                    showInMenu: true,
                    showSideMenu: false,
                },
                path: '/user/safe',
                component: () => import( '@/pages/user/UserHome.vue'),
                name:'user.safe',
            },

        ]
    },
    {
        path: "/userOrder",
        component: () => import('@/pages/user/UserHomeLayout.vue'),
        meta: {
            title: '订单管理',
            showInMenu: true,
            showSideMenu: true,
        },
        name: 'orders',
        children:[
            {
                meta: {
                    title: '我的订单',
                    showInMenu: true,
                    showSideMenu: true,
                },
                path: '/user/orders',
                component: () => import( '@/pages/user/UserOrder.vue'),
                name:'user.orders',
            },
            {
                meta: {
                    title: '订单详情',
                    showInMenu: false,
                    showSideMenu: false,
                },
                path: '/user/orderDetail',
                component: () => import( '@/pages/order/UserOrderDetailPage.vue'),
                name:'user.orderDetail',
            },
            {
                meta: {
                    title: '批量下单',
                    showInMenu: true,
                    showSideMenu: true,
                },
                path: '/user/batchOrder',
                component: () => import( '@/pages/order/BatchOrderByExcel.vue'),
                name:'user.batchOrder',
            },
        ]
    },
    {
        path: "/userCollect",
        component: () => import('@/pages/user/UserHomeLayout.vue'),
        meta: {
            title: '我的收藏',
            showInMenu: true,
            showSideMenu: true,
        },
        name: 'user.collect',
        children:[
            {
                meta: {
                    title: '商品收藏',
                    showInMenu: true,
                    showSideMenu: true,
                },
                path: '/user/collect',
                component: () => import( '@/pages/user/UserProductCollectList.vue'),
                name:'user.collect',
            },
        ]
    },
    {
        path: "/funds",
        component: () => import('@/pages/user/UserHomeLayout.vue'),
        meta: {
            title: '资产管理',
            showInMenu: true,
            showSideMenu: true,
        },
        name: 'funds',
        children:[
            {
                meta: {
                    title: '我的账单',
                    showInMenu: true,
                    showSideMenu: true,
                },
                path: '/user/funds',
                component: () => import( '@/pages/funds/UserWalletFundsList.vue'),
                name:'user.funds',
            },
            {
                meta: {
                    title: '线下充值',
                    showInMenu: true,
                    showSideMenu: true,
                },
                path: '/user/financeAccount',
                component: () => import( '@/pages/funds/UserFinanceAccountRecordList.vue'),
                name:'user.financeAccount',
            },
            {
                meta: {
                    title: '账户备案',
                    showInMenu: false,
                    showSideMenu: false,
                },
                path: '/user/addFinanceAccount',
                component: () => import( '@/pages/funds/UserFinanceAccountRecordAdd.vue'),
                name:'user.addFinanceAccount',
            },
        ]

    }

];
